import { render, staticRenderFns } from "./verlangerung-widget.vue?vue&type=template&id=06ebd512&scoped=true"
import script from "./verlangerung-widget.vue?vue&type=script&lang=js"
export * from "./verlangerung-widget.vue?vue&type=script&lang=js"
import style0 from "./verlangerung-widget.vue?vue&type=style&index=0&id=06ebd512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ebd512",
  null
  
)

export default component.exports